import React, { useState } from "react";

/**
 * Reusable Tooltip Component
 * @param {React.ReactNode} children - The element that triggers the tooltip
 * @param {string} content - The tooltip text content
 * @param {string} position - Tooltip position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top' | 'bottom' | 'left' | 'right'
 * @param {string} className - Additional CSS classes for the tooltip
 */
const Tooltip = ({ 
  children, 
  content, 
  position = "top", 
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const getPositionClasses = () => {
    const positions = {
      "top": "bottom-full left-1/2 -translate-x-1/2 mb-2",
      "top-left": "bottom-full right-0 mb-2",
      "top-right": "bottom-full left-0 mb-2",
      "bottom": "top-full left-1/2 -translate-x-1/2 mt-2",
      "bottom-left": "top-full right-0 mt-2",
      "bottom-right": "top-full left-0 mt-2",
      "left": "right-full top-1/2 -translate-y-1/2 mr-2",
      "right": "left-full top-1/2 -translate-y-1/2 ml-2",
    };
    return positions[position] || positions["top"];
  };

  const getArrowClasses = () => {
    const arrows = {
      "top": "top-full left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-b-transparent border-t-[#1A212F]",
      "top-left": "top-full right-2 border-l-transparent border-r-transparent border-b-transparent border-t-[#1A212F]",
      "top-right": "top-full left-2 border-l-transparent border-r-transparent border-b-transparent border-t-[#1A212F]",
      "bottom": "bottom-full left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-t-transparent border-b-[#1A212F]",
      "bottom-left": "bottom-full right-2 border-l-transparent border-r-transparent border-t-transparent border-b-[#1A212F]",
      "bottom-right": "bottom-full left-2 border-l-transparent border-r-transparent border-t-transparent border-b-[#1A212F]",
      "left": "left-full top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-r-transparent border-l-[#1A212F]",
      "right": "right-full top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-l-transparent border-r-[#1A212F]",
    };
    return arrows[position] || arrows["top"];
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        className="cursor-pointer"
      >
        {children}
      </div>

      {isVisible && content && (
        <div
          className={`absolute z-50 ${getPositionClasses()} animate-fadeIn`}
          style={{ minWidth: "max-content" }}
        >
          {/* Tooltip Content */}
          <div
            className={`bg-[#1A212F] text-white text-sm font-medium px-3 py-2 rounded-lg shadow-lg whitespace-nowrap ${className}`}
          >
            {content}
          </div>

          {/* Tooltip Arrow */}
          <div
            className={`absolute w-0 h-0 border-4 ${getArrowClasses()}`}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
